import React, { useState, useEffect, useCallback } from 'react';
import { styles, colors } from '../../styles/globalStyles';

// ─── Feriados Brasileiros ─────────────────────────────────────────────────────

function calcularPascoa(ano) {
  const a = ano % 19, b = Math.floor(ano / 100), c = ano % 100;
  const d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4), k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const mes = Math.floor((h + l - 7 * m + 114) / 31);
  const dia = ((h + l - 7 * m + 114) % 31) + 1;
  return new Date(ano, mes - 1, dia);
}

function feriadosBrasileiros(ano) {
  const p = calcularPascoa(ano);
  const add = (d, n) => { const x = new Date(d); x.setDate(x.getDate() + n); return x; };
  const fmt = d => d.toISOString().split('T')[0];

  return [
    // Fixos nacionais
    { data: `${ano}-01-01`, nome: 'Confraternização Universal' },
    { data: `${ano}-04-21`, nome: 'Tiradentes' },
    { data: `${ano}-05-01`, nome: 'Dia do Trabalho' },
    { data: `${ano}-09-07`, nome: 'Independência do Brasil' },
    { data: `${ano}-10-12`, nome: 'N.S. Aparecida' },
    { data: `${ano}-11-02`, nome: 'Finados' },
    { data: `${ano}-11-15`, nome: 'Proclamação da República' },
    { data: `${ano}-11-20`, nome: 'Consciência Negra' },
    { data: `${ano}-12-25`, nome: 'Natal' },
    // Móveis
    { data: fmt(add(p, -48)), nome: 'Segunda de Carnaval' },
    { data: fmt(add(p, -47)), nome: 'Terça de Carnaval' },
    { data: fmt(add(p, -2)),  nome: 'Sexta-feira Santa' },
    { data: fmt(p),           nome: 'Páscoa' },
    { data: fmt(add(p, 60)),  nome: 'Corpus Christi' },
  ].sort((a, b) => a.data.localeCompare(b.data));
}

// ─── Helpers ─────────────────────────────────────────────────────────────────

function proximaSegunda() {
  const d = new Date();
  const dia = d.getDay(); // 0=Dom, 1=Seg, ...
  const diff = dia === 0 ? 1 : dia === 1 ? 7 : 8 - dia;
  d.setDate(d.getDate() + diff);
  return d.toISOString().split('T')[0];
}

function addDays(dateStr, n) {
  const d = new Date(dateStr + 'T12:00:00');
  d.setDate(d.getDate() + n);
  return d.toISOString().split('T')[0];
}

function formatarData(dateStr) {
  if (!dateStr) return '—';
  const d = new Date(String(dateStr).includes('T') ? dateStr : dateStr + 'T12:00:00');
  return d.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' });
}

function hoje() {
  return new Date().toISOString().split('T')[0];
}

function horasOpcoes() {
  const opts = [];
  for (let h = 0; h < 24; h++) {
    opts.push(`${String(h).padStart(2, '0')}:00`);
    opts.push(`${String(h).padStart(2, '0')}:30`);
  }
  return opts;
}

// ─── Estilos inline ───────────────────────────────────────────────────────────

const mkAlert = (type) => ({
  padding: '0.75rem 1rem',
  borderRadius: '0.5rem',
  fontSize: '0.875rem',
  marginBottom: '1rem',
  ...(type === 'error'
    ? { backgroundColor: '#fef2f2', color: '#dc2626', border: '1px solid #fca5a5' }
    : { backgroundColor: '#f0fdf4', color: '#15803d', border: '1px solid #4ade80' }),
});

const mkBadge = (bg, color, border) => ({
  display: 'inline-flex',
  alignItems: 'center',
  padding: '2px 8px',
  borderRadius: '12px',
  fontSize: '0.72rem',
  fontWeight: '700',
  backgroundColor: bg,
  color,
  border: `1px solid ${border}`,
  whiteSpace: 'nowrap',
});

const opcaoCardStyle = (ativo) => ({
  display: 'flex',
  alignItems: 'flex-start',
  gap: '0.75rem',
  padding: '0.875rem 1rem',
  backgroundColor: ativo ? '#eff6ff' : '#f8fafc',
  border: `2px solid ${ativo ? colors.primary : '#e2e8f0'}`,
  borderRadius: '0.75rem',
  cursor: 'pointer',
  transition: 'all 0.15s ease',
  userSelect: 'none',
});

const stepBadgeStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 26,
  height: 26,
  borderRadius: '50%',
  backgroundColor: colors.primary,
  color: '#fff',
  fontSize: '0.78rem',
  fontWeight: '700',
  flexShrink: 0,
};

// ─── Indicador de passos ──────────────────────────────────────────────────────

function IndicadorPassos({ atual }) {
  const passos = [
    { n: 1, label: 'Gerar Semana' },
    { n: 2, label: 'Publicação' },
  ];
  return (
    <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '1.75rem' }}>
      {passos.map((p, i) => {
        const concluido = atual > p.n;
        const ativo     = atual === p.n;
        const circleBg  = concluido ? '#16a34a' : ativo ? colors.primary : '#e2e8f0';
        const labelColor = ativo ? colors.primary : concluido ? '#16a34a' : colors.gray;
        return (
          <React.Fragment key={p.n}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', minWidth: 64 }}>
              <div style={{
                width: 34, height: 34, borderRadius: '50%',
                backgroundColor: circleBg,
                color: (ativo || concluido) ? '#fff' : colors.gray,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontWeight: '700', fontSize: '0.9rem',
                boxShadow: ativo ? `0 0 0 4px ${colors.primary}33` : 'none',
                transition: 'all 0.25s',
              }}>
                {concluido ? '✓' : p.n}
              </div>
              <div style={{ marginTop: 6, fontSize: '0.72rem', fontWeight: '600', color: labelColor, textAlign: 'center' }}>
                {p.label}
              </div>
            </div>
            {i < passos.length - 1 && (
              <div style={{
                flex: 1, height: 3, marginTop: 15, marginBottom: 0,
                marginLeft: 6, marginRight: 6,
                backgroundColor: concluido ? '#16a34a' : '#e2e8f0',
                borderRadius: 2,
                transition: 'background-color 0.25s',
              }} />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}

// ─── Sumário da geração ───────────────────────────────────────────────────────

function SumarioGeracao({ resultado, onRegerar }) {
  return (
    <div style={{
      padding: '1.25rem',
      backgroundColor: '#f0fdf4',
      border: '2px solid #4ade80',
      borderRadius: '0.75rem',
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: '0.5rem', marginBottom: '1rem' }}>
        <div>
          <div style={{ fontWeight: '700', color: '#15803d', fontSize: '1rem' }}>
            ✅ Semana gerada em modo rascunho
          </div>
          <div style={{ fontSize: '0.82rem', color: '#16a34a', marginTop: '2px' }}>
            {formatarData(resultado.data_inicio)} — {formatarData(resultado.data_fim)}
          </div>
        </div>
        <button
          onClick={onRegerar}
          style={{ ...styles.button, ...styles.buttonOutline, ...styles.buttonSmall }}
        >
          ↺ Regerar
        </button>
      </div>

      <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap' }}>
        <StatBox label="Vagas criadas"  value={resultado.vagas_geradas}           cor="#15803d" />
        {resultado.alunos_fixos_aplicados > 0 && (
          <StatBox label="Vagas fixas"  value={resultado.alunos_fixos_aplicados}  cor="#854d0e" />
        )}
        <StatBox label="Status" value="Rascunho" cor="#1d4ed8" />
      </div>

      <div style={{ marginTop: '0.75rem', fontSize: '0.78rem', color: '#16a34a' }}>
        As vagas estão em rascunho e invisíveis para os alunos. Avance para agendar a publicação.
      </div>
    </div>
  );
}

function StatBox({ label, value, cor }) {
  return (
    <div style={{
      padding: '0.5rem 0.875rem',
      backgroundColor: '#fff',
      borderRadius: '0.5rem',
      border: '1px solid #d1fae5',
      textAlign: 'center',
      minWidth: '80px',
    }}>
      <div style={{ fontWeight: '700', fontSize: '1.2rem', color: cor }}>{value}</div>
      <div style={{ fontSize: '0.68rem', color: '#6b7280' }}>{label}</div>
    </div>
  );
}

// ─── Lista de agendamentos existentes ─────────────────────────────────────────

function ListaAgendamentos({ agendamentos, configuracoes, onExcluir, loading }) {
  return (
    <div style={{ ...styles.card, padding: '1.5rem', marginTop: '1.5rem' }}>
      <h4 style={{ margin: '0 0 1rem 0', color: colors.dark, display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
        📅 Publicações Agendadas
        <span style={{ fontSize: '0.85rem', fontWeight: '400', color: colors.gray }}>
          ({agendamentos.length})
        </span>
      </h4>

      {loading && agendamentos.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '1.5rem', color: colors.gray }}>Carregando...</div>
      ) : agendamentos.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '1.5rem', color: colors.gray, fontSize: '0.875rem' }}>
          Nenhuma publicação agendada.
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
          {agendamentos.map(ag => {
            const config = configuracoes.find(c => c.id === ag.configuracao_id);
            const dataPubl = ag.data_publicacao
              ? formatarData(ag.data_publicacao)
              : ag.dia_semana != null
              ? ['Dom','Seg','Ter','Qua','Qui','Sex','Sáb'][ag.dia_semana]
              : '—';
            const hora = ag.hora_publicacao
              ? String(ag.hora_publicacao).substring(0, 5)
              : ag.hora_execucao
              ? String(ag.hora_execucao).substring(0, 5)
              : '—';
            const executado = !!ag.executado;

            return (
              <div
                key={ag.id}
                style={{
                  padding: '0.875rem 1rem',
                  borderRadius: '0.75rem',
                  backgroundColor: executado ? '#f0fdf4' : colors.grayLight,
                  border: `2px solid ${executado ? '#4ade80' : '#e2e8f0'}`,
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  gap: '0.75rem',
                  flexWrap: 'wrap',
                }}
              >
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', flexWrap: 'wrap', marginBottom: '0.25rem' }}>
                    <span style={{ fontWeight: '700', color: colors.dark }}>
                      {config?.nome || (ag.configuracao_id ? `Configuração #${ag.configuracao_id}` : 'Publicar rascunhos existentes')}
                    </span>
                    {executado
                      ? <span style={mkBadge('#d1fae5', '#15803d', '#4ade80')}>✓ Executado</span>
                      : <span style={mkBadge('#dbeafe', '#1d4ed8', '#93c5fd')}>⏳ Aguardando</span>
                    }
                  </div>
                  <div style={{ fontSize: '0.82rem', color: colors.gray }}>
                    🕐 {dataPubl} às {hora}
                  </div>
                </div>
                {!executado && (
                  <button
                    onClick={() => onExcluir(ag.id)}
                    style={{ ...styles.button, ...styles.buttonDanger, ...styles.buttonSmall, flexShrink: 0 }}
                  >
                    Excluir
                  </button>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

// ─── Painel de edição de vagas rascunho ──────────────────────────────────────

function PainelEditarVagas({ vagas, editandoVaga, setEditandoVaga, onSalvar, salvandoVaga, onTrancar, trancandoId }) {
  const DIAS_NOMES = ['Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado'];

  // Agrupa vagas por dia usando horário de Brasília
  const vagasPorDia = vagas.reduce((acc, v) => {
    const d = new Date(v.data_hora);
    const key = d.toLocaleDateString('pt-BR', { timeZone: 'America/Sao_Paulo' });
    const diaSemana = d.toLocaleDateString('pt-BR', { weekday: 'long', timeZone: 'America/Sao_Paulo' });
    const diaNum = d.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', timeZone: 'America/Sao_Paulo' });
    if (!acc[key]) acc[key] = { label: `${diaSemana.charAt(0).toUpperCase() + diaSemana.slice(1)}, ${diaNum}`, vagas: [], sortKey: d.getTime() };
    acc[key].vagas.push(v);
    return acc;
  }, {});

  const diasOrdenados = Object.entries(vagasPorDia).sort((a, b) => a[1].sortKey - b[1].sortKey);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
      {diasOrdenados.map(([dia, grupo]) => (
        <div key={dia}>
          <div style={{ fontSize: '0.78rem', fontWeight: '700', color: colors.primary, marginBottom: '0.4rem', paddingBottom: '0.25rem', borderBottom: `1px solid ${colors.grayLight}` }}>
            📅 {grupo.label}
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.3rem' }}>
            {grupo.vagas.map(v => {
              const hora = new Date(v.data_hora).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit', timeZone: 'America/Sao_Paulo' });
              const isEditando = editandoVaga?.id === v.id;
              const isFixo = !!v.aluno_fixo_id;
              const isTrancada = !!v.trancada;
              const isTrancando = trancandoId === v.id;

              let bgColor = isFixo ? '#fffbeb' : isTrancada ? '#fef2f2' : '#f8fafc';
              let borderColor = isFixo ? '#fcd34d' : isTrancada ? '#fca5a5' : '#e2e8f0';

              return (
                <div key={v.id} style={{
                  display: 'flex', alignItems: 'center', gap: '0.5rem', flexWrap: 'wrap',
                  padding: '0.45rem 0.625rem',
                  backgroundColor: bgColor,
                  borderRadius: '6px',
                  border: `1px solid ${borderColor}`,
                  opacity: isTrancando ? 0.6 : 1,
                  transition: 'all 0.15s ease',
                }}>
                  {/* Hora */}
                  <span style={{ fontSize: '0.75rem', fontWeight: '700', color: colors.gray, minWidth: 38, flexShrink: 0 }}>
                    {hora}
                  </span>

                  {/* Descrição / input de edição */}
                  {isEditando ? (
                    <>
                      <input
                        autoFocus
                        value={editandoVaga.descricao}
                        onChange={e => setEditandoVaga(prev => ({ ...prev, descricao: e.target.value }))}
                        style={{ ...styles.formInput, flex: 1, fontSize: '0.8rem', padding: '0.3rem 0.5rem', minWidth: 120 }}
                        onKeyDown={e => { if (e.key === 'Enter') onSalvar(); if (e.key === 'Escape') setEditandoVaga(null); }}
                      />
                      <button
                        onClick={onSalvar}
                        disabled={salvandoVaga}
                        style={{ ...styles.button, ...styles.buttonPrimary, ...styles.buttonSmall, fontSize: '0.72rem', padding: '0.3rem 0.6rem', flexShrink: 0 }}
                      >
                        {salvandoVaga ? '...' : '✓'}
                      </button>
                      <button
                        onClick={() => setEditandoVaga(null)}
                        style={{ ...styles.button, ...styles.buttonOutline, ...styles.buttonSmall, fontSize: '0.72rem', padding: '0.3rem 0.6rem', flexShrink: 0 }}
                      >
                        ✕
                      </button>
                    </>
                  ) : (
                    <>
                      <span style={{ flex: 1, fontSize: '0.8rem', color: isTrancada && !isFixo ? '#dc2626' : colors.dark, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', textDecoration: isTrancada && !isFixo ? 'line-through' : 'none' }}>
                        {v.descricao || (isFixo ? '(nota opcional)' : '(sem descrição)')}
                      </span>

                      {/* Badges */}
                      {isFixo && <span style={mkBadge('#fef9c3', '#854d0e', '#eab308')}>⭐ {v.aluno_fixo_nome || 'Fixo'}</span>}
                      {isTrancada && !isFixo && <span style={mkBadge('#fee2e2', '#dc2626', '#fca5a5')}>🔒 Trancada</span>}
                      {!isTrancada && !isFixo && <span style={mkBadge('#dbeafe', '#1e40af', '#93c5fd')}>Rascunho</span>}

                      {/* Botão editar descrição — disponível para vagas normais abertas e para vagas fixas */}
                      {(!isTrancada || isFixo) && (
                        <button
                          onClick={() => setEditandoVaga({ id: v.id, descricao: v.descricao || '' })}
                          title={isFixo ? 'Adicionar nota à vaga fixa' : 'Editar descrição'}
                          style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '2px 4px', color: colors.gray, fontSize: '0.85rem', flexShrink: 0 }}
                        >
                          ✏️
                        </button>
                      )}

                      {/* Botão Trancar / Destrancar */}
                      <button
                        onClick={() => onTrancar(v.id, !isTrancada)}
                        disabled={isTrancando}
                        title={isTrancada ? 'Destrancar vaga' : 'Trancar vaga'}
                        style={{
                          ...styles.button,
                          ...(isTrancada ? styles.buttonOutline : styles.buttonDanger),
                          ...styles.buttonSmall,
                          fontSize: '0.72rem',
                          padding: '0.25rem 0.55rem',
                          flexShrink: 0,
                          opacity: isTrancando ? 0.5 : 1,
                        }}
                      >
                        {isTrancando ? '...' : isTrancada ? '🔓 Abrir' : '🔒 Trancar'}
                      </button>
                    </>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}

// ─── Componente principal ─────────────────────────────────────────────────────

export const AgendadorPublicacao = ({ createApi, isMobile = false }) => {
  const [passo, setPasso]         = useState(1);
  const [configuracoes, setConfiguracoes] = useState([]);
  const [agendamentos, setAgendamentos]   = useState([]);
  const [loading, setLoading]             = useState(false);
  const [loadingAction, setLoadingAction] = useState(false);
  const [erro, setErro]     = useState('');
  const [sucesso, setSucesso] = useState('');

  // Formulário passo 1
  const [form1, setForm1] = useState({
    configuracao_id: '',
    data_inicio: proximaSegunda(),
    aplicar_fixos: true,
  });

  // Resultado da geração (retorno da API)
  const [resultadoGeracao, setResultadoGeracao] = useState(null);

  // Vagas rascunho da semana gerada (para edição antes de publicar)
  const [vagasRascunho, setVagasRascunho] = useState([]);
  const [loadingVagas, setLoadingVagas]   = useState(false);
  const [editandoVaga, setEditandoVaga]   = useState(null); // { id, descricao }
  const [salvandoVaga, setSalvandoVaga]   = useState(false);
  const [trancandoId, setTrancandoId]     = useState(null);
  const [paineEditAberto, setPainelEditAberto] = useState(true);
  const [trancandoFeriados, setTrancandoFeriados] = useState(false);
  const [salvandoModelo, setSalvandoModelo] = useState(false);
  const [aplicandoModelo, setAplicandoModelo] = useState(false);

  // Modelos nomeados
  const [modelosSalvos, setModelosSalvos]           = useState([]);
  const [showModalSalvar, setShowModalSalvar]       = useState(false);
  const [nomeNovoModelo, setNomeNovoModelo]         = useState('');
  const [salvandoModeloNomeado, setSalvandoModeloNomeado] = useState(false);
  const [aplicandoModeloNomeado, setAplicandoModeloNomeado] = useState(null); // id do modelo
  const [excluindoModelo, setExcluindoModelo]       = useState(null); // id

  // Formulário passo 2
  const [form2, setForm2] = useState({
    tipo: 'agora',          // 'agora' | 'agendar'
    data_publicacao: hoje(),
    hora_publicacao: '08:00',
  });

  // ── Carrega dados iniciais ────────────────────────────────────────────────
  const carregarDados = useCallback(async () => {
    setLoading(true);
    try {
      const api = createApi();
      const [agRes, cfgRes] = await Promise.all([
        api.get('/admin/agendamentos-automaticos'),
        api.get('/admin/configuracoes-semana'),
      ]);
      setAgendamentos(agRes.data);
      setConfiguracoes(cfgRes.data);
    } catch {
      setErro('Erro ao carregar dados');
    } finally {
      setLoading(false);
    }
  }, [createApi]);

  const carregarModelos = useCallback(async () => {
    try {
      const api = createApi();
      const r = await api.get('/admin/modelos-grade');
      setModelosSalvos(Array.isArray(r.data) ? r.data : []);
    } catch { /* silencioso */ }
  }, [createApi]);

  // Carrega rascunhos da semana atual/próxima na montagem
  const carregarRascunhosExistentes = useCallback(async () => {
    try {
      const api = createApi();
      // Tenta próxima semana (padrão do form) e semana atual
      const periodos = [
        { ini: proximaSegunda(), fim: addDays(proximaSegunda(), 6) },
        { ini: hoje(),           fim: addDays(hoje(), 6) },
      ];
      for (const { ini, fim } of periodos) {
        const resp = await api.get(`/admin/vagas-periodo?data_inicio=${ini}&data_fim=${fim}`);
        const vagas = Array.isArray(resp.data) ? resp.data.filter(v => v.rascunho) : [];
        if (vagas.length > 0) { setVagasRascunho(vagas); return; }
      }
    } catch { /* silencioso */ }
  }, [createApi]);

  useEffect(() => {
    carregarDados();
    carregarRascunhosExistentes();
    carregarModelos();
  }, [carregarDados, carregarRascunhosExistentes, carregarModelos]);

  // ── Passo 1: Gerar semana ─────────────────────────────────────────────────
  const carregarVagasRascunho = useCallback(async (dataInicio, dataFim) => {
    if (!dataInicio) return;
    const fim = dataFim || addDays(dataInicio, 6);
    setLoadingVagas(true);
    try {
      const api = createApi();
      const resp = await api.get(`/admin/vagas-periodo?data_inicio=${dataInicio}&data_fim=${fim}`);
      const todas = Array.isArray(resp.data) ? resp.data : [];
      setVagasRascunho(todas.filter(v => v.rascunho));
    } catch {
      setVagasRascunho([]);
    } finally {
      setLoadingVagas(false);
    }
  }, [createApi]);

  const gerarSemana = async () => {
    if (!form1.configuracao_id) { setErro('Selecione uma configuração'); return; }
    if (!form1.data_inicio)     { setErro('Informe a data de início');   return; }
    setErro('');
    setSucesso('');
    setLoadingAction(true);
    try {
      const api = createApi();
      const resp = await api.post('/admin/gerar-semana-configuracao', {
        configuracao_id:    parseInt(form1.configuracao_id),
        data_inicio:        form1.data_inicio,
        aplicar_alunos_fixos: form1.aplicar_fixos,
      });
      setResultadoGeracao(resp.data);
      setEditandoVaga(null);
      // Usa diretamente form1.data_inicio (a data que o admin escolheu) + 6 dias
      // Isso garante consistência com o que foi gerado
      await carregarVagasRascunho(form1.data_inicio, addDays(form1.data_inicio, 6));
    } catch (err) {
      setErro(err.response?.data?.error || 'Erro ao gerar semana');
    } finally {
      setLoadingAction(false);
    }
  };

  const salvarDescricaoVaga = async () => {
    if (!editandoVaga) return;
    setSalvandoVaga(true);
    try {
      const api = createApi();
      await api.put(`/admin/vaga/${editandoVaga.id}`, { descricao: editandoVaga.descricao });
      setVagasRascunho(prev => prev.map(v =>
        v.id === editandoVaga.id ? { ...v, descricao: editandoVaga.descricao } : v
      ));
      setEditandoVaga(null);
    } catch (err) {
      setErro(err.response?.data?.error || 'Erro ao salvar vaga');
    } finally {
      setSalvandoVaga(false);
    }
  };

  const trancarVaga = async (vagaId, trancada) => {
    setTrancandoId(vagaId);
    setErro('');
    try {
      const api = createApi();
      const endpoint = trancada ? `/admin/vaga/${vagaId}/trancar` : `/admin/vaga/${vagaId}/destrancar`;
      await api.post(endpoint);
      setVagasRascunho(prev => prev.map(v =>
        v.id === vagaId
          ? { ...v, trancada, ...(!trancada && { aluno_fixo_id: null, aluno_fixo_nome: null }) }
          : v
      ));
    } catch (err) {
      setErro(err.response?.data?.error || 'Erro ao alterar status da vaga');
    } finally {
      setTrancandoId(null);
    }
  };

  const trancarFeriados = async () => {
    const { dataInicio, dataFim } = detectarSemanaRascunho();
    if (!dataInicio) { setErro('Gere a semana primeiro'); return; }

    // Cobre os dois anos que podem aparecer em uma semana (virada de ano)
    const anoIni = new Date(dataInicio + 'T12:00:00').getFullYear();
    const anoFim = new Date(dataFim   + 'T12:00:00').getFullYear();
    const todos = [...feriadosBrasileiros(anoIni), ...(anoFim !== anoIni ? feriadosBrasileiros(anoFim) : [])];
    const noIntervalo = todos.filter(f => f.data >= dataInicio && f.data <= dataFim);

    if (noIntervalo.length === 0) {
      setSucesso(`✅ Nenhum feriado nacional entre ${formatarData(dataInicio)} e ${formatarData(dataFim)}. Nada a trancar.`);
      return;
    }

    const lista = noIntervalo.map(f => `• ${new Date(f.data + 'T12:00:00').toLocaleDateString('pt-BR')} — ${f.nome}`).join('\n');
    if (!window.confirm(`Trancar vagas nos seguintes feriados?\n\n${lista}`)) return;

    setTrancandoFeriados(true);
    setErro('');
    try {
      const api = createApi();
      const r = await api.post('/admin/vagas/trancar-feriados', {
        data_inicio: dataInicio,
        data_fim:    dataFim,
        feriados:    noIntervalo.map(f => f.data),
      });
      setSucesso(r.data.message || `${r.data.total ?? '?'} vagas trancadas nos feriados.`);
      await carregarVagasRascunho(dataInicio, dataFim);
    } catch (err) {
      setErro(err.response?.data?.error || 'Erro ao trancar feriados');
    } finally {
      setTrancandoFeriados(false);
    }
  };

  const salvarModelo = async () => {
    if (!form1.configuracao_id) { setErro('Selecione uma configuração'); return; }
    const { dataInicio, dataFim } = detectarSemanaRascunho();
    if (!dataInicio) { setErro('Gere a semana primeiro'); return; }
    if (!window.confirm('Salvar as descrições como padrão desta configuração? Próximas gerações usarão essas descrições automaticamente.')) return;
    setSalvandoModelo(true);
    setErro('');
    try {
      const api = createApi();
      const r = await api.post(`/admin/configuracoes-semana/${form1.configuracao_id}/salvar-modelo`, {
        data_inicio: dataInicio,
        data_fim:    dataFim,
      });
      setSucesso(r.data.message);
      await carregarDados(); // recarrega configs para atualizar badge de modelo
    } catch (err) {
      setErro(err.response?.data?.error || 'Erro ao salvar modelo');
    } finally {
      setSalvandoModelo(false);
    }
  };

  const aplicarModelo = async () => {
    if (!form1.configuracao_id) { setErro('Selecione uma configuração com grade salva'); return; }
    const cfg = configuracoes.find(c => String(c.id) === String(form1.configuracao_id));
    const temModelo = cfg?.descricoes_modelo && Object.keys(cfg.descricoes_modelo).length > 0;
    if (!temModelo) { setErro(`A configuração "${cfg?.nome}" não possui grade padrão salva`); return; }
    const { dataInicio, dataFim } = detectarSemanaRascunho();
    if (!window.confirm(`Aplicar grade padrão de "${cfg.nome}" às vagas desta semana?`)) return;
    setAplicandoModelo(true); setErro('');
    try {
      const api = createApi();
      const r = await api.post('/admin/vagas/aplicar-modelo', {
        configuracao_id: parseInt(form1.configuracao_id),
        data_inicio: dataInicio,
        data_fim: dataFim,
      });
      setSucesso(r.data.message);
      await carregarVagasRascunho(dataInicio, dataFim);
    } catch (err) {
      setErro(err.response?.data?.error || 'Erro ao aplicar grade');
    } finally {
      setAplicandoModelo(false);
    }
  };

  // Retorna { dataInicio, dataFim } da semana dos rascunhos
  const detectarSemanaRascunho = () => {
    if (resultadoGeracao) {
      return { dataInicio: resultadoGeracao.data_inicio, dataFim: resultadoGeracao.data_fim };
    }
    if (vagasRascunho.length > 0) {
      const datas = vagasRascunho
        .map(v => new Date(v.data_hora).toLocaleDateString('pt-BR', { timeZone: 'America/Sao_Paulo' })
          .split('/').reverse().join('-'))
        .sort();
      return { dataInicio: datas[0], dataFim: datas[datas.length - 1] };
    }
    return { dataInicio: form1.data_inicio, dataFim: addDays(form1.data_inicio, 6) };
  };

  const salvarModeloNomeado = async () => {
    const nome = nomeNovoModelo.trim();
    if (!nome) return;
    const { dataInicio, dataFim } = detectarSemanaRascunho();
    if (!dataInicio) { setErro('Gere ou selecione uma semana com rascunhos primeiro'); return; }
    setSalvandoModeloNomeado(true);
    setErro('');
    try {
      const api = createApi();
      const r = await api.post('/admin/modelos-grade', {
        nome,
        configuracao_id: form1.configuracao_id || null,
        data_inicio: dataInicio,
        data_fim: dataFim,
      });
      setSucesso(r.data.message);
      setShowModalSalvar(false);
      setNomeNovoModelo('');
      await carregarModelos();
    } catch (err) {
      setErro(err.response?.data?.error || 'Erro ao salvar modelo');
    } finally {
      setSalvandoModeloNomeado(false);
    }
  };

  const aplicarModeloNomeado = async (modeloId) => {
    const modelo = modelosSalvos.find(m => m.id === modeloId);
    if (!modelo) return;
    const { dataInicio, dataFim } = detectarSemanaRascunho();
    if (!dataInicio) { setErro('Não há rascunhos carregados para aplicar o modelo'); return; }
    if (!window.confirm(`Aplicar modelo "${modelo.nome}" às vagas desta semana?\nAs descrições das vagas normais serão substituídas.`)) return;
    setAplicandoModeloNomeado(modeloId);
    setErro('');
    try {
      const api = createApi();
      const r = await api.post('/admin/vagas/aplicar-modelo-grade', {
        modelo_id: modeloId,
        data_inicio: dataInicio,
        data_fim: dataFim,
      });
      setSucesso(r.data.message);
      await carregarVagasRascunho(dataInicio, dataFim);
    } catch (err) {
      setErro(err.response?.data?.error || 'Erro ao aplicar modelo');
    } finally {
      setAplicandoModeloNomeado(null);
    }
  };

  const excluirModeloNomeado = async (modeloId) => {
    const modelo = modelosSalvos.find(m => m.id === modeloId);
    if (!window.confirm(`Excluir o modelo "${modelo?.nome}"? Esta ação não pode ser desfeita.`)) return;
    setExcluindoModelo(modeloId);
    try {
      const api = createApi();
      const r = await api.delete(`/admin/modelos-grade/${modeloId}`);
      setSucesso(r.data.message);
      setModelosSalvos(prev => prev.filter(m => m.id !== modeloId));
    } catch (err) {
      setErro(err.response?.data?.error || 'Erro ao excluir modelo');
    } finally {
      setExcluindoModelo(null);
    }
  };

  const resetarGeracao = () => {
    setResultadoGeracao(null);
    setVagasRascunho([]);
    setEditandoVaga(null);
    setSucesso('');
    setErro('');
  };

  const irParaPasso2 = () => {
    setErro('');
    setSucesso('');
    setPasso(2);
  };

  const voltarParaPasso1 = () => {
    setErro('');
    setSucesso('');
    setPasso(1);
  };

  // ── Passo 2: Confirmar publicação ─────────────────────────────────────────
  const confirmarPublicacao = async () => {
    if (form2.tipo === 'agendar' && !form2.data_publicacao) {
      setErro('Informe a data para o agendamento');
      return;
    }
    setErro('');
    setSucesso('');
    setLoadingAction(true);
    try {
      const api = createApi();

      if (form2.tipo === 'agora') {
        // Se veio de geração: usa as datas do resultado; senão publica a semana atual com rascunhos
        if (resultadoGeracao) {
          await api.post('/admin/publicar-com-datas', {
            data_inicio: resultadoGeracao.data_inicio,
            data_fim:    resultadoGeracao.data_fim,
          });
        } else {
          await api.post('/admin/publicar-semana');
        }
        setSucesso(
          `✅ ${resultadoGeracao ? resultadoGeracao.vagas_geradas : vagasRascunho.length} vagas publicadas! Alunos já podem se agendar.`
        );
      } else {
        const cfgId = parseInt(form1.configuracao_id) || null;
        await api.post('/admin/agendamento-automatico', {
          configuracao_id: cfgId,
          data_publicacao: form2.data_publicacao,
          hora_publicacao: form2.hora_publicacao,
        });
        setSucesso(
          `✅ Publicação agendada para ${formatarData(form2.data_publicacao)} às ${form2.hora_publicacao}.`
        );
        await carregarDados();
      }

      // Volta ao início
      setPasso(1);
      setResultadoGeracao(null);
      setVagasRascunho([]);
      setEditandoVaga(null);
      setForm1({ configuracao_id: '', data_inicio: proximaSegunda(), aplicar_fixos: true });
      setForm2({ tipo: 'agora', data_publicacao: hoje(), hora_publicacao: '08:00' });
    } catch (err) {
      setErro(err.response?.data?.error || 'Erro ao confirmar publicação');
    } finally {
      setLoadingAction(false);
    }
  };

  const excluirAgendamento = async (id) => {
    if (!window.confirm('Excluir este agendamento?')) return;
    try {
      const api = createApi();
      await api.delete(`/admin/agendamento-automatico/${id}`);
      setAgendamentos(prev => prev.filter(a => a.id !== id));
    } catch {
      setErro('Erro ao excluir agendamento');
    }
  };

  const configSelecionada = configuracoes.find(c => c.id === parseInt(form1.configuracao_id));

  // ── Render ────────────────────────────────────────────────────────────────
  return (
    <div style={{ width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}>
      <h3 style={{ marginBottom: '1.5rem', color: colors.dark }}>
        🕒 Publicação Automática de Semana
      </h3>

      <IndicadorPassos atual={passo} />

      {erro   && <div style={mkAlert('error')}>{erro}</div>}
      {sucesso && <div style={mkAlert('success')}>{sucesso}</div>}

      {/* ════════════════════════════════ PASSO 1 ════════════════════════════ */}
      {passo === 1 && (
        <div style={{ ...styles.card, marginBottom: '1.5rem', padding: '1.5rem' }}>
          <h4 style={{ margin: '0 0 1.25rem 0', color: colors.dark, display: 'flex', alignItems: 'center', gap: '0.625rem' }}>
            <span style={stepBadgeStyle}>1</span>
            Configurar e Gerar Semana
          </h4>

          {/* Seleção de modelo / configuração */}
          {!resultadoGeracao && (
            <div style={{ marginBottom: '1.25rem' }}>
              <label style={{ ...styles.formLabel, marginBottom: '0.6rem', display: 'block' }}>
                Escolha uma configuração ou modelo salvo *
              </label>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '0.625rem' }}>
                {configuracoes.map(c => {
                  const temModelo = c.descricoes_modelo && Object.keys(c.descricoes_modelo).length > 0;
                  const qtdModelo = temModelo ? Object.keys(c.descricoes_modelo).length : 0;
                  const ativo = String(form1.configuracao_id) === String(c.id);
                  return (
                    <div
                      key={c.id}
                      onClick={() => !resultadoGeracao && setForm1(f => ({ ...f, configuracao_id: String(c.id) }))}
                      style={{
                        padding: '0.75rem',
                        borderRadius: '0.75rem',
                        border: `2px solid ${ativo ? colors.primary : '#e2e8f0'}`,
                        backgroundColor: ativo ? '#eff6ff' : '#f8fafc',
                        cursor: 'pointer',
                        transition: 'all 0.15s',
                        position: 'relative',
                      }}
                    >
                      {temModelo && (
                        <span style={{
                          position: 'absolute', top: 6, right: 6,
                          ...mkBadge('#d1fae5', '#065f46', '#6ee7b7'),
                        }}>
                          💾 Modelo
                        </span>
                      )}
                      <div style={{ fontWeight: '600', fontSize: '0.875rem', color: colors.dark, paddingRight: temModelo ? '4.5rem' : 0 }}>
                        {c.nome}
                      </div>
                      {c.descricao && (
                        <div style={{ fontSize: '0.75rem', color: colors.gray, marginTop: '0.25rem' }}>{c.descricao}</div>
                      )}
                      {temModelo && (
                        <div style={{ fontSize: '0.72rem', color: '#065f46', marginTop: '0.3rem' }}>
                          {qtdModelo} descrição{qtdModelo !== 1 ? 'ões' : ''} salva{qtdModelo !== 1 ? 's' : ''}
                        </div>
                      )}
                      {!temModelo && (
                        <div style={{ fontSize: '0.72rem', color: colors.gray, marginTop: '0.3rem' }}>Sem modelo salvo</div>
                      )}
                    </div>
                  );
                })}
              </div>
              {!form1.configuracao_id && (
                <div style={{ marginTop: '0.4rem', fontSize: '0.78rem', color: '#dc2626' }}>
                  Selecione uma configuração para continuar
                </div>
              )}
            </div>
          )}

          {/* Data */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '1rem', marginBottom: '1.25rem' }}>
            <div style={styles.formGroup}>
              <label style={styles.formLabel}>Segunda-feira da semana *</label>
              <input
                type="date"
                value={form1.data_inicio}
                onChange={e => setForm1({ ...form1, data_inicio: e.target.value })}
                style={styles.formInput}
                disabled={!!resultadoGeracao}
              />
              {form1.data_inicio && (
                <div style={{ marginTop: '0.3rem', fontSize: '0.78rem', color: colors.gray }}>
                  {formatarData(form1.data_inicio)} até {formatarData(addDays(form1.data_inicio, 6))}
                </div>
              )}
            </div>
          </div>

          {/* Checkbox alunos fixos */}
          <label style={{
            display: 'flex',
            alignItems: 'flex-start',
            gap: '0.75rem',
            padding: '0.875rem 1rem',
            backgroundColor: form1.aplicar_fixos ? '#f0fdf4' : '#f8fafc',
            border: `2px solid ${form1.aplicar_fixos ? '#4ade80' : '#e2e8f0'}`,
            borderRadius: '0.75rem',
            cursor: resultadoGeracao ? 'default' : 'pointer',
            marginBottom: '1.25rem',
            transition: 'all 0.15s ease',
            userSelect: 'none',
            opacity: resultadoGeracao ? 0.7 : 1,
          }}>
            <input
              type="checkbox"
              checked={form1.aplicar_fixos}
              onChange={e => setForm1({ ...form1, aplicar_fixos: e.target.checked })}
              disabled={!!resultadoGeracao}
              style={{ marginTop: 2, flexShrink: 0, accentColor: colors.primary }}
            />
            <div>
              <div style={{ fontWeight: '600', color: colors.dark, marginBottom: 2 }}>
                Respeitar Alunos Fixos
              </div>
              <div style={{ fontSize: '0.8rem', color: colors.gray }}>
                Reserva automaticamente as vagas para alunos com horários fixos cadastrados.
              </div>
            </div>
          </label>

          {/* Resultado da geração OU botão de gerar */}
          {resultadoGeracao ? (
            <>
              <SumarioGeracao resultado={resultadoGeracao} onRegerar={resetarGeracao} />

              {/* Botões de ação em massa para o rascunho */}
              <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr 1fr' : 'repeat(auto-fill, minmax(160px, 1fr))', gap: '0.5rem', marginTop: '1rem', width: '100%' }}>
                <button
                  onClick={trancarFeriados}
                  disabled={trancandoFeriados || vagasRascunho.length === 0}
                  style={{ ...styles.button, backgroundColor: '#f59e0b', color: '#fff', border: 'none', ...styles.buttonSmall, opacity: trancandoFeriados ? 0.7 : 1, width: '100%' }}
                >
                  {trancandoFeriados ? '⏳...' : '🇧🇷 Trancar Feriados'}
                </button>
                <button
                  onClick={aplicarModelo}
                  disabled={aplicandoModelo || vagasRascunho.length === 0 || !form1.configuracao_id}
                  style={{ ...styles.button, backgroundColor: '#0ea5e9', color: '#fff', border: 'none', ...styles.buttonSmall, opacity: aplicandoModelo ? 0.7 : 1, width: '100%' }}
                >
                  {aplicandoModelo ? '⏳...' : '📂 Aplicar Padrão'}
                </button>
                <button
                  onClick={() => { setNomeNovoModelo(''); setShowModalSalvar(true); }}
                  disabled={vagasRascunho.length === 0}
                  style={{ ...styles.button, backgroundColor: '#7c3aed', color: '#fff', border: 'none', ...styles.buttonSmall, width: '100%' }}
                >
                  💾 Salvar Modelo
                </button>
                <button
                  onClick={salvarModelo}
                  disabled={salvandoModelo || vagasRascunho.length === 0 || !form1.configuracao_id}
                  style={{ ...styles.button, backgroundColor: '#8b5cf6', color: '#fff', border: 'none', ...styles.buttonSmall, opacity: salvandoModelo ? 0.7 : 1, width: '100%' }}
                >
                  {salvandoModelo ? '⏳...' : '⭐ Definir Padrão'}
                </button>
              </div>

              <div style={{ marginTop: '0.75rem', border: '1px solid #e2e8f0', borderRadius: '0.75rem', overflow: 'hidden' }}>
                <button
                  onClick={() => setPainelEditAberto(v => !v)}
                  style={{
                    width: '100%', padding: '0.75rem 1rem',
                    backgroundColor: '#f8fafc', border: 'none', cursor: 'pointer',
                    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                    fontSize: '0.875rem', fontWeight: '600', color: colors.dark,
                  }}
                >
                  <span>📋 Editar vagas da semana antes de publicar</span>
                  <span style={{ fontSize: '0.75rem', color: colors.gray }}>
                    {vagasRascunho.length} vagas {paineEditAberto ? '▲' : '▼'}
                  </span>
                </button>

                {paineEditAberto && (
                  <div style={{ maxHeight: '420px', overflowY: 'auto', backgroundColor: '#fff', padding: '0.75rem' }}>
                    {loadingVagas ? (
                      <div style={{ textAlign: 'center', padding: '1.5rem', color: colors.gray, fontSize: '0.875rem' }}>
                        Carregando vagas...
                      </div>
                    ) : vagasRascunho.length === 0 ? (
                      <div style={{ textAlign: 'center', padding: '1.5rem', color: colors.gray, fontSize: '0.875rem' }}>
                        Nenhuma vaga encontrada.
                      </div>
                    ) : (
                      <PainelEditarVagas
                        vagas={vagasRascunho}
                        editandoVaga={editandoVaga}
                        setEditandoVaga={setEditandoVaga}
                        onSalvar={salvarDescricaoVaga}
                        salvandoVaga={salvandoVaga}
                        onTrancar={trancarVaga}
                        trancandoId={trancandoId}
                      />
                    )}
                  </div>
                )}
              </div>

              <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '1.25rem' }}>
                <button
                  onClick={irParaPasso2}
                  style={{
                    ...styles.button,
                    ...styles.buttonPrimary,
                    display: 'flex', alignItems: 'center', gap: '0.5rem',
                  }}
                >
                  Agendar Publicação →
                </button>
              </div>
            </>
          ) : (
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <button
                onClick={gerarSemana}
                disabled={loadingAction || !form1.configuracao_id || !form1.data_inicio}
                style={{
                  ...styles.button,
                  ...styles.buttonPrimary,
                  opacity: loadingAction || !form1.configuracao_id ? 0.7 : 1,
                  cursor:  loadingAction || !form1.configuracao_id ? 'not-allowed' : 'pointer',
                  display: 'flex', alignItems: 'center', gap: '0.5rem',
                }}
              >
                {loadingAction ? '⏳ Gerando...' : '🗓️ Gerar Semana em Rascunho'}
              </button>
            </div>
          )}
        </div>
      )}

      {/* ════════ PAINEL RASCUNHOS (visível no passo 1 mesmo sem gerar) ════════ */}
      {passo === 1 && !resultadoGeracao && vagasRascunho.length > 0 && (
        <div style={{ ...styles.card, marginBottom: '1.5rem', padding: '1.5rem' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.75rem', flexWrap: 'wrap', gap: '0.5rem' }}>
            <h4 style={{ margin: 0, color: colors.dark, fontSize: '1rem' }}>
              📋 Rascunhos existentes — editar antes de publicar
            </h4>
            <span style={mkBadge('#dbeafe', '#1e40af', '#93c5fd')}>{vagasRascunho.length} vagas em rascunho</span>
          </div>
          <p style={{ margin: '0 0 0.75rem 0', fontSize: '0.82rem', color: colors.gray }}>
            Estas vagas já foram geradas mas ainda não publicadas. Edite e depois clique em "Agendar Publicação →".
          </p>
          {/* Seletor de configuração inline */}
          <div style={{ marginBottom: '0.75rem' }}>
            <select
              value={form1.configuracao_id}
              onChange={e => setForm1(f => ({ ...f, configuracao_id: e.target.value }))}
              style={{ ...styles.formInput, fontSize: '0.8rem', padding: '0.3rem 0.5rem', height: 'auto', width: '100%', maxWidth: '320px' }}
            >
              <option value="">Selecionar configuração / grade...</option>
              {configuracoes.map(c => {
                const temModelo = c.descricoes_modelo && Object.keys(c.descricoes_modelo).length > 0;
                return <option key={c.id} value={c.id}>{temModelo ? '💾 ' : ''}{c.nome}</option>;
              })}
            </select>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr 1fr' : 'repeat(auto-fill, minmax(160px, 1fr))', gap: '0.5rem', marginBottom: '0.75rem', width: '100%' }}>
            <button
              onClick={trancarFeriados}
              disabled={trancandoFeriados}
              style={{ ...styles.button, backgroundColor: '#f59e0b', color: '#fff', border: 'none', ...styles.buttonSmall, width: '100%' }}
            >
              {trancandoFeriados ? '⏳...' : '🇧🇷 Trancar Feriados'}
            </button>
            <button
              onClick={aplicarModelo}
              disabled={aplicandoModelo || !form1.configuracao_id}
              style={{ ...styles.button, backgroundColor: '#0ea5e9', color: '#fff', border: 'none', ...styles.buttonSmall, opacity: !form1.configuracao_id ? 0.5 : 1, width: '100%' }}
            >
              {aplicandoModelo ? '⏳...' : '📂 Aplicar Padrão'}
            </button>
            <button
              onClick={() => { setNomeNovoModelo(''); setShowModalSalvar(true); }}
              style={{ ...styles.button, backgroundColor: '#7c3aed', color: '#fff', border: 'none', ...styles.buttonSmall, width: '100%' }}
            >
              💾 Salvar Modelo
            </button>
            <button
              onClick={salvarModelo}
              disabled={salvandoModelo || !form1.configuracao_id}
              style={{ ...styles.button, backgroundColor: '#8b5cf6', color: '#fff', border: 'none', ...styles.buttonSmall, opacity: !form1.configuracao_id ? 0.5 : 1, width: '100%' }}
            >
              {salvandoModelo ? '⏳...' : '⭐ Definir Padrão'}
            </button>
          </div>
          <div style={{ maxHeight: '380px', overflowY: 'auto', border: '1px solid #e2e8f0', borderRadius: '0.5rem', padding: '0.75rem', backgroundColor: '#f8fafc' }}>
            <PainelEditarVagas
              vagas={vagasRascunho}
              editandoVaga={editandoVaga}
              setEditandoVaga={setEditandoVaga}
              onSalvar={salvarDescricaoVaga}
              salvandoVaga={salvandoVaga}
              onTrancar={trancarVaga}
              trancandoId={trancandoId}
            />
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '1rem' }}>
            <button
              onClick={irParaPasso2}
              style={{ ...styles.button, ...styles.buttonPrimary, display: 'flex', alignItems: 'center', gap: '0.5rem' }}
            >
              Agendar Publicação →
            </button>
          </div>
        </div>
      )}

      {/* ════════════════════════════════ PASSO 2 ════════════════════════════ */}
      {passo === 2 && (resultadoGeracao || vagasRascunho.length > 0) && (
        <div style={{ ...styles.card, marginBottom: '1.5rem', padding: '1.5rem' }}>
          <h4 style={{ margin: '0 0 1.25rem 0', color: colors.dark, display: 'flex', alignItems: 'center', gap: '0.625rem' }}>
            <span style={stepBadgeStyle}>2</span>
            Quando Publicar?
          </h4>

          {/* Resumo do rascunho gerado */}
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.875rem',
            padding: '0.875rem 1rem',
            backgroundColor: '#f0fdf4',
            border: '1px solid #4ade80',
            borderRadius: '0.75rem',
            marginBottom: '1.5rem',
            flexWrap: 'wrap',
          }}>
            <span style={{ fontSize: '1.5rem' }}>📋</span>
            <div>
              <div style={{ fontWeight: '700', color: '#15803d', fontSize: '0.95rem' }}>Rascunho pronto</div>
              <div style={{ fontSize: '0.82rem', color: '#16a34a' }}>
                {resultadoGeracao
                  ? `${resultadoGeracao.vagas_geradas} vagas • ${formatarData(resultadoGeracao.data_inicio)} — ${formatarData(resultadoGeracao.data_fim)}${resultadoGeracao.alunos_fixos_aplicados > 0 ? ` • ${resultadoGeracao.alunos_fixos_aplicados} fixas` : ''}`
                  : `${vagasRascunho.length} vagas em rascunho`}
              </div>
            </div>
          </div>

          {/* Opções de publicação */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem', marginBottom: '1.25rem' }}>
            {/* Opção: Publicar agora */}
            <label style={opcaoCardStyle(form2.tipo === 'agora')}>
              <input
                type="radio"
                name="tipoPub"
                value="agora"
                checked={form2.tipo === 'agora'}
                onChange={() => setForm2({ ...form2, tipo: 'agora' })}
                style={{ marginTop: 2, accentColor: colors.primary, flexShrink: 0 }}
              />
              <div>
                <div style={{ fontWeight: '600', color: colors.dark, marginBottom: 2 }}>
                  ⚡ Publicar agora
                </div>
                <div style={{ fontSize: '0.8rem', color: colors.gray }}>
                  As vagas ficam visíveis imediatamente para os alunos agendarem.
                </div>
              </div>
            </label>

            {/* Opção: Agendar para depois */}
            <label style={opcaoCardStyle(form2.tipo === 'agendar')}>
              <input
                type="radio"
                name="tipoPub"
                value="agendar"
                checked={form2.tipo === 'agendar'}
                onChange={() => setForm2({ ...form2, tipo: 'agendar' })}
                style={{ marginTop: 2, accentColor: colors.primary, flexShrink: 0 }}
              />
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: '600', color: colors.dark, marginBottom: 2 }}>
                  🕐 Agendar para depois
                </div>
                <div style={{ fontSize: '0.8rem', color: colors.gray }}>
                  O sistema publicará automaticamente na data e hora escolhidas.
                </div>

                {form2.tipo === 'agendar' && (
                  <div style={{ display: 'flex', gap: '0.75rem', marginTop: '0.875rem', flexWrap: 'wrap' }}>
                    <div style={{ flex: '1 1 160px' }}>
                      <label style={{ ...styles.formLabel, fontSize: '0.8rem' }}>
                        Data de publicação
                      </label>
                      <input
                        type="date"
                        value={form2.data_publicacao}
                        min={hoje()}
                        onChange={e => setForm2({ ...form2, data_publicacao: e.target.value })}
                        style={styles.formInput}
                      />
                    </div>
                    <div style={{ flex: '1 1 130px' }}>
                      <label style={{ ...styles.formLabel, fontSize: '0.8rem' }}>Horário</label>
                      <select
                        value={form2.hora_publicacao}
                        onChange={e => setForm2({ ...form2, hora_publicacao: e.target.value })}
                        style={styles.formSelect}
                      >
                        {horasOpcoes().map(h => (
                          <option key={h} value={h}>{h}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                )}
              </div>
            </label>
          </div>

          {/* Aviso quando agendar para depois */}
          {form2.tipo === 'agendar' && (
            <div style={{
              padding: '0.75rem 1rem',
              backgroundColor: '#fffbeb',
              border: '1px solid #fcd34d',
              borderRadius: '0.5rem',
              fontSize: '0.8rem',
              color: '#92400e',
              marginBottom: '1rem',
            }}>
              ⚠️ Na data agendada o sistema <strong>gerará e publicará automaticamente</strong> uma nova semana
              com base na configuração <strong>{configSelecionada?.nome || `#${form1.configuracao_id}`}</strong>.
            </div>
          )}

          {/* Rodapé: voltar / confirmar */}
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '0.5rem', gap: '0.75rem' }}>
            <button
              onClick={voltarParaPasso1}
              style={{ ...styles.button, ...styles.buttonOutline }}
            >
              ← Voltar
            </button>
            <button
              onClick={confirmarPublicacao}
              disabled={loadingAction || (form2.tipo === 'agendar' && !form2.data_publicacao)}
              style={{
                ...styles.button,
                ...styles.buttonPrimary,
                opacity: loadingAction || (form2.tipo === 'agendar' && !form2.data_publicacao) ? 0.7 : 1,
                cursor:  loadingAction || (form2.tipo === 'agendar' && !form2.data_publicacao) ? 'not-allowed' : 'pointer',
                display: 'flex', alignItems: 'center', gap: '0.5rem',
              }}
            >
              {loadingAction
                ? '⏳ Processando...'
                : form2.tipo === 'agora'
                ? '⚡ Publicar Agora'
                : '📅 Confirmar Agendamento'}
            </button>
          </div>
        </div>
      )}

      {/* ════════════════════════════ MODELOS SALVOS ════════════════════════ */}
      <div style={{ ...styles.card, marginBottom: '1.5rem', padding: '1.5rem' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.75rem', flexWrap: 'wrap', gap: '0.5rem' }}>
          <h4 style={{ margin: 0, color: colors.dark, display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            🗂️ Modelos de Grade Salvos
            <span style={{ fontSize: '0.8rem', fontWeight: '400', color: colors.gray }}>
              ({modelosSalvos.length})
            </span>
          </h4>
          <button
            onClick={() => { setNomeNovoModelo(''); setShowModalSalvar(true); setErro(''); setSucesso(''); }}
            disabled={vagasRascunho.length === 0}
            title={vagasRascunho.length === 0 ? 'Gere uma semana em rascunho primeiro' : 'Salvar a grade atual como modelo nomeado'}
            style={{
              ...styles.button, backgroundColor: '#7c3aed', color: '#fff', border: 'none',
              ...styles.buttonSmall, opacity: vagasRascunho.length === 0 ? 0.4 : 1,
              cursor: vagasRascunho.length === 0 ? 'not-allowed' : 'pointer',
            }}
          >
            💾 Salvar Grade como Modelo
          </button>
        </div>

        <div style={{ padding: '0.75rem', backgroundColor: '#fffbeb', border: '1px solid #fcd34d', borderRadius: '0.5rem', marginBottom: '0.875rem', fontSize: '0.8rem', color: '#92400e' }}>
          <strong>Como usar:</strong> Gere uma semana em rascunho (Passo 1 acima) → edite as vagas se quiser → clique em
          &nbsp;<strong>💾 Salvar Grade como Modelo</strong> com um nome (ex: "Grade Padrão").
          Da próxima semana, clique <strong>▶ Aplicar</strong> no modelo desejado para copiar as descrições automaticamente.
        </div>

        {modelosSalvos.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '1.5rem', color: colors.gray, fontSize: '0.875rem', backgroundColor: '#f8fafc', borderRadius: '0.5rem', border: '1px dashed #e2e8f0' }}>
            Nenhum modelo salvo ainda. Gere uma semana em rascunho e use o botão acima para criar o primeiro modelo.
          </div>
        ) : (
          <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr 1fr' : 'repeat(auto-fill, minmax(220px, 1fr))', gap: '0.75rem', width: '100%' }}>
            {modelosSalvos.map(m => {
              const isAplicando = aplicandoModeloNomeado === m.id;
              const isExcluindo = excluindoModelo === m.id;
              const entradas = m.descricoes ? Object.values(m.descricoes) : [];
              const qtd = entradas.length;
              const qtdTrancadas = entradas.filter(e => typeof e === 'object' ? e.trancada : false).length;
              const dataCriacao = m.created_at ? formatarData(m.created_at) : '—';
              const semanaRef = m.semana_referencia ? formatarData(m.semana_referencia) : null;
              return (
                <div key={m.id} style={{
                  padding: '0.75rem',
                  borderRadius: '0.75rem',
                  border: '1px solid #e2e8f0',
                  backgroundColor: '#f8fafc',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '0.35rem',
                  opacity: (isAplicando || isExcluindo) ? 0.6 : 1,
                  transition: 'opacity 0.15s',
                  minWidth: 0,
                  overflow: 'hidden',
                }}>
                  <div style={{ fontWeight: '700', fontSize: '0.82rem', color: colors.dark, wordBreak: 'break-word', overflowWrap: 'anywhere' }}>{m.nome}</div>
                  {m.configuracao_nome && (
                    <div style={{ fontSize: '0.72rem', color: colors.gray, wordBreak: 'break-word' }}>
                      📋 {m.configuracao_nome}
                    </div>
                  )}
                  <div style={{ fontSize: '0.68rem', color: colors.gray }}>
                    {qtd} horário{qtd !== 1 ? 's' : ''} salvo{qtd !== 1 ? 's' : ''}
                    {qtdTrancadas > 0 && <span style={{ color: '#dc2626', marginLeft: 3 }}>• 🔒 {qtdTrancadas}</span>}
                    {semanaRef && <span> • ref. {semanaRef}</span>}
                  </div>
                  <div style={{ fontSize: '0.68rem', color: '#9ca3af' }}>
                    Salvo em {dataCriacao}
                  </div>
                  <div style={{ display: 'flex', gap: '0.35rem', marginTop: '0.25rem', flexWrap: 'wrap' }}>
                    <button
                      onClick={() => aplicarModeloNomeado(m.id)}
                      disabled={isAplicando || vagasRascunho.length === 0}
                      title={vagasRascunho.length === 0 ? 'Carregue rascunhos para aplicar' : `Aplicar "${m.nome}"`}
                      style={{
                        ...styles.button, backgroundColor: '#0ea5e9', color: '#fff', border: 'none',
                        fontSize: '0.7rem', padding: '0.3rem 0.55rem', flex: 1,
                        opacity: vagasRascunho.length === 0 ? 0.5 : 1,
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {isAplicando ? '⏳...' : '▶ Aplicar'}
                    </button>
                    <button
                      onClick={() => excluirModeloNomeado(m.id)}
                      disabled={isExcluindo}
                      style={{ ...styles.button, ...styles.buttonDanger, fontSize: '0.7rem', padding: '0.3rem 0.55rem' }}
                    >
                      {isExcluindo ? '...' : '🗑'}
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>

      {/* Modal: Salvar Rascunho como Modelo */}
      {showModalSalvar && (
        <div style={{
          position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex', alignItems: 'flex-start', justifyContent: 'center',
          zIndex: 1000, padding: '1rem', overflowY: 'auto', WebkitOverflowScrolling: 'touch',
        }}
          onClick={e => { if (e.target === e.currentTarget) setShowModalSalvar(false); }}
        >
          <div style={{
            backgroundColor: '#fff', borderRadius: '1rem',
            padding: isMobile ? '1.25rem' : '1.75rem',
            width: '100%', maxWidth: '440px', boxShadow: '0 20px 60px rgba(0,0,0,0.25)',
            margin: 'auto', boxSizing: 'border-box',
          }}>
            <h4 style={{ margin: '0 0 0.5rem 0', color: colors.dark }}>💾 Salvar Grade como Modelo</h4>
            <p style={{ margin: '0 0 1.25rem 0', fontSize: '0.82rem', color: colors.gray }}>
              Dê um nome para identificar este modelo. As descrições das vagas desta semana serão salvas e poderão ser aplicadas em semanas futuras.
            </p>

            <div style={styles.formGroup}>
              <label style={styles.formLabel}>Nome do modelo *</label>
              <input
                autoFocus
                type="text"
                value={nomeNovoModelo}
                onChange={e => setNomeNovoModelo(e.target.value)}
                placeholder="Ex: Semana Padrão, Grade Verão, Horário Reduzido..."
                style={styles.formInput}
                onKeyDown={e => { if (e.key === 'Enter') salvarModeloNomeado(); if (e.key === 'Escape') setShowModalSalvar(false); }}
                maxLength={200}
              />
              <div style={{ fontSize: '0.75rem', color: colors.gray, marginTop: '0.3rem' }}>
                {vagasRascunho.length} vagas em rascunho serão analisadas. Apenas descrições editadas (não auto-geradas) são salvas.
              </div>
            </div>

            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.75rem', marginTop: '1.25rem' }}>
              <button
                onClick={() => setShowModalSalvar(false)}
                style={{ ...styles.button, ...styles.buttonOutline }}
              >
                Cancelar
              </button>
              <button
                onClick={salvarModeloNomeado}
                disabled={salvandoModeloNomeado || !nomeNovoModelo.trim()}
                style={{
                  ...styles.button, backgroundColor: '#7c3aed', color: '#fff', border: 'none',
                  opacity: salvandoModeloNomeado || !nomeNovoModelo.trim() ? 0.6 : 1,
                }}
              >
                {salvandoModeloNomeado ? '⏳ Salvando...' : '💾 Salvar Modelo'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ════════════════════════════ AGENDAMENTOS EXISTENTES ════════════════ */}
      <ListaAgendamentos
        agendamentos={agendamentos}
        configuracoes={configuracoes}
        onExcluir={excluirAgendamento}
        loading={loading}
      />
    </div>
  );
};
